import './price.css';

const PLANS = [
  {
    id: 'professional',
    eyebrow: 'Starting point',
    name: 'Professional',
    blurb: 'Itinerary, vouchers, CRM and invoicing on one shared rate engine.',
    price: '$480',
    priceUnit: 'per user / year',
    priceNote: '**Paid annually',
    altPrice: '$60',
    altNote: 'per user / month, billed monthly',
    features: [
      "'Access to Itinerary' + Vouchers + CRM + Invoice + a vast database of all hotels, room types and parks across East & Southern Africa",
      'Complete access to our patented* Auto-Costing, setting room rate, child and occupancy policies',
      'P&L Report and other Basic Financial Reports at Quotation Level',
      'Standard Support via Email/Whatsapp/Google-Meetups',
      'No customizations',
      '(Optional) Extraction of Contracts**',
    ],
    tone: 'highlight',
  },
  {
    id: 'enterprise',
    eyebrow: 'Most operators land here',
    name: 'Enterprise Costing',
    blurb: 'Everything in Professional, built out for teams running full B2B operations.',
    price: '$960',
    priceUnit: 'per user / year',
    priceNote: '**Paid annually',
    altPrice: '$100',
    altNote: 'per user / month, billed monthly',
    features: [
      "'Professional Edition'",
      'Support for B2B quote generation',
      'Premium Support via Email/Whatsapp/Google-Meetups',
      'Dedicated Account Manager',
      'Detailed Accounts and P&L Reports and Other Financial Reports (at Quotation level & Company level)',
      'Access to Finance & Operations modules & reports',
      'Connected eMail delivery of vouchers, invoices & quotations',
      'Role based Access',
      'Customizations Allowed++',
      'Extraction of Contracts++',
      'One time fee for Training, Implementation, & Orchestration apply',
      'Quote accurately from Day 1 — every lodge contract loaded and compiled before you log in',
    ],
    tone: 'default',
  },
  {
    id: 'plus',
    eyebrow: 'Built around you',
    name: 'Enterprise Plus',
    blurb: 'Enterprise Costing plus the customisation and infrastructure larger operators need.',
    price: '$ **',
    priceUnit: 'per user / month',
    priceNote: '**Paid annually · contact for rates',
    altPrice: null,
    altNote: null,
    features: [
      'All of `Enterprise Costing` + Lots of customisation and new features to suit your business needs.',
      'Support for B2B quote generation',
      'XERO and other 3rd Party Integrations',
      '(Optional) Separate Compute Instance for the best performance',
      'Dedicated Account Executive/Customer success',
      'Redundant server infrastructure — dedicated backup server accessible via separate URL for uninterrupted business continuity.',
      '**Please drop a message for rates',
    ],
    tone: 'default',
  },
];

const Price = () => {
  return (
    <div className="body-div">
      <section className="pricing-hero">
        <div className="wrap">
          <p className="eyebrow">Pricing</p>
          <h1>Pick the plan that fits your team.</h1>
          <p className="lede">
            Every plan runs on the same rate engine. The difference is how much of the
            operation you want Twigaa to carry for you.
          </p>
        </div>
      </section>

      <section className="pricing-plans">
        <div className="wrap mt-5">
          <div className="plans-grid">
            {PLANS.map((plan) => (
              <article
                key={plan.id}
                className={`plan-card${plan.tone === 'highlight' ? ' plan-card--highlight' : ''}`}
              >
                {plan.tone === 'highlight' && <span className="plan-badge">Most popular</span>}

                <p className="eyebrow plan-eyebrow">{plan.eyebrow}</p>
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-blurb">{plan.blurb}</p>

                <div className="plan-price-block">
                  <div className="plan-price">
                    <span className="amount">{plan.price}</span>
                    <span className="unit">{plan.priceUnit}</span>
                  </div>
                  <p className="plan-price-note">{plan.priceNote}</p>
                  {plan.altPrice && (
                    <p className="plan-alt-price">
                      <span className="alt-amount">{plan.altPrice}</span> {plan.altNote}
                    </p>
                  )}
                </div>

                <ul className="plan-features">
                  {plan.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <div className="plans-footnotes">
            <p>++ Conditions apply.</p>
            <p>** Contract uploading into the system is charged separately.</p>
            <p>
              * Free trial available — contact{' '}
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@twigaa.ai" target="_blank" rel="noopener noreferrer">
                sales@twigaa.ai
              </a>
            </p>
            <p>Best experienced on the latest Google Chrome with 10–20 Mbps or faster.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Price;